<template>
  <div class="page-breadcrumb">
    <b-breadcrumb>
      <b-breadcrumb-item :to="{name: 'admin'}">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
      </b-breadcrumb-item>
      <b-breadcrumb-item
          v-if="items.length"
          v-for="(item, index) in items"
          :key="index"
          :to="item.path"
      >
        {{ item.text }}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{ name }}</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 v-if="!noTitle" class="page-title">{{ pageTitle }}</h1>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "AdminBreadcrumb",
  props: {
    items: {
      type: Array
    },
    name: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    noTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pageTitle() {
      if (this.title) {
        return this.title;
      }

      return this.name;
    },
    maxDate() {
      return moment().format('YYYY-MM-DD');
    },
    startDate() {
      return moment(this.filters.start_date).format('L');
    },
    endDate() {
      return moment(this.filters.end_date).format('L');
    },
  }
}
</script>